<script setup>
// import { Link } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import { useForm } from '@inertiajs/vue3'
import Portrait from '@/Shared/Portrait.vue'
import Icon from '@/Shared/Icon.vue'

let form = useForm({
  name: '',
  description: '',
  order: '',
  color: '#000000'
})

function store() {
  form.post('/lessons/levels/store')
}

const breadcrumbs = [
  { label: 'Clases', href: '/lessons' },
  { label: 'Niveles', href: '/lessons/levels' },
  { label: 'Crear' }
]
</script>

<template>
  <Portrait
    title="Crear nivel"
    subtitle="Configura un nuevo nivel para las clases del club"
    :breadcrumbs="breadcrumbs"
    :footer-actions="true"
  >
    <form class="space-y-6" @submit.prevent="store">
      <div class="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6 rounded-r-md">
        <div class="flex">
          <div class="flex-shrink-0">
            <Icon name="InformationCircle" class="h-5 w-5 text-blue-400" />
          </div>
          <div class="ml-3">
            <p class="text-sm text-blue-700">
              Los niveles te permiten organizar las clases por dificultad o categoría. Asigna un
              color distintivo para identificarlos fácilmente.
            </p>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden p-6">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          <TextInput
            v-model="form.name"
            :error="form.errors.name"
            label="Nombre"
            class="md:col-span-3"
          />
          <TextInput
            v-model="form.color"
            :error="form.errors.color"
            type="color"
            label="Color"
            class="md:col-span-1"
          />
          <TextareaInput
            v-model="form.description"
            :error="form.errors.description"
            class="md:col-span-4"
            label="Descripción"
          />
        </div>
      </div>
    </form>

    <template #footer>
      <div class="flex items-center justify-end w-full">
        <LoadingButton :loading="form.processing" class="btn-indigo" @click="store">
          Crear
        </LoadingButton>
      </div>
    </template>
  </Portrait>
</template>
